import { formatUTCDate } from "../../utils/functions";
import { getBillStatusKey } from "../../utils/utilities";
import BillNumber from "../bill/BillNumber";

const billTypes = {
  DDAY: "Dday",
  DISCOUNT: "Descuento",
  DRAFT: "NO PROCESADO",
};

export const getTableData = (reportType, reportData, userType = "", states) => {
  switch (reportType) {
    case "PROVIDERS":
      return providerData(reportData, states);
    case "BILLS":
      return billsData(reportData, userType, states);
    case "CUSTOMERS":
      return customersData(reportData, states);
    default:
      break;
  }
};

const providerData = (reportData, states) => {
  var data = [];
  reportData.map((item) => {
    const state =
      item.provider.status === "TRANSITORY" ? "ACTIVE" : item.provider.status;
    data.push({
      businessId: item.businessId,
      name: item.companyName,
      state: states[state],
      contact: item.provider?.notificationNameProvider,
      type: item.provider?.toBillDiscount ? "Descuento" : "DDay",
      billAmount: item.provider?.quantityBills,
      email: item.provider?.notificationEmailProvider,
      account:
        item.provider.accounts !== null && item.provider.accounts.length > 0
          ? item.provider.accounts[0].accountNumber
          : "",
      currency: item.provider?.accounts[0]?.accountCurrency,
      invitationStatus: states[item.provider.invitationStatus],
      relationType: item.relationType,
    });
  });

  return data;
};

const billsData = (reportData, userType, states) => {
  var data = [];
  const isCSA = userType === "CSA";

  reportData.map((item) => {
    const billStatusKey = getBillStatusKey(item.status, userType);
    const mount = isCSA
      ? item.totalAmount.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : item.totalAmount;
    data.push({
      id: item.id,
      billNumber: {
        component: BillNumber,
        props: { billNumber: item.billNumber },
      },
      status: billTypes[item.type],
      statusType: states[billStatusKey],
      cif: item.company.cif,
      cedJuridica:
        userType === "PRO" ? item.company.businessId : item.provider.businessId,
      companyName:
        userType === "PRO"
          ? item.company.companyName
          : item.provider.companyName,
      fechaCarga: new Date(item.createDate).toLocaleDateString("es-ES"),
      fechaEmision: formatUTCDate(item.dateOfIssue),
      fechaVencimiento: formatUTCDate(item.expirationDate),
      mount: `${item.currencyDetail.currencySymbol}  ${mount}`,

      statusRef: item.status,
      isH2h: item.isH2h,
      relationType: item.relationType,
    });
  });

  return data;
};

const customersData = (reportData, states) => {
  var data = [];
  reportData.map((item) => {
    data.push({
      cif: item.cif,
      status: states[item.company.status],
      identification: item.businessId,
      name: item.companyName,
      country: item.country.name,
    });
  });

  return data;
};
